export default __webpack_public_path__ + "static/media/Ies_Cooper.87df352d.png";